import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createTable } from '@atlaskit/editor-tables/utils';
import { TABLE_MAX_WIDTH } from '../table-resizing/utils/consts';
var NESTED_TABLE_DEFAULT_ROWS = 2;
var NESTED_TABLE_DEFAULT_COLS = 2;
export var createTableWithWidth = function createTableWithWidth(_ref) {
  var isTableScalingEnabled = _ref.isTableScalingEnabled,
    isTableAlignmentEnabled = _ref.isTableAlignmentEnabled,
    isFullWidthModeEnabled = _ref.isFullWidthModeEnabled,
    isCommentEditor = _ref.isCommentEditor,
    isChromelessEditor = _ref.isChromelessEditor,
    isTableResizingEnabled = _ref.isTableResizingEnabled,
    isNestedTable = _ref.isNestedTable,
    createTableProps = _ref.createTableProps;
  return function (schema) {
    var attrsOverrides = {};
    if (isNestedTable) {
      attrsOverrides.rowsCount = createTableProps !== null && createTableProps !== void 0 && createTableProps.rowsCount ? createTableProps === null || createTableProps === void 0 ? void 0 : createTableProps.rowsCount : NESTED_TABLE_DEFAULT_ROWS;
      attrsOverrides.colsCount = createTableProps !== null && createTableProps !== void 0 && createTableProps.colsCount ? createTableProps === null || createTableProps === void 0 ? void 0 : createTableProps.colsCount : NESTED_TABLE_DEFAULT_COLS;
    }
    if (isTableScalingEnabled && isFullWidthModeEnabled && !isCommentEditor) {
      attrsOverrides.tableWidth = TABLE_MAX_WIDTH;
    }
    if (isTableAlignmentEnabled && (isFullWidthModeEnabled || isCommentEditor)) {
      attrsOverrides.layout = 'align-start';
    }
    if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) {
      attrsOverrides.tableWidth = 'inherit';
    }
    return createTable(_objectSpread(_objectSpread({
      schema: schema
    }, createTableProps), attrsOverrides));
  };
};